import React, { useContext } from 'react';
import CreatePasswordForm from '../features/auth/pages/create-password/CreatePasswordForm';
import useCreatePassword from '../features/auth/pages/create-password/useCreatePassword';


const CreatePasswordPage = () => {
    const { createPassword } = useCreatePassword();

    return (
        <CreatePasswordForm onCreatePasswordSubmit={createPassword}/>
    )
}

export default CreatePasswordPage;
